import { render, staticRenderFns } from "./OrganisationCardMenu.vue?vue&type=template&id=9799c35e&"
import script from "./OrganisationCardMenu.vue?vue&type=script&lang=js&"
export * from "./OrganisationCardMenu.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationCardMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports